import './Deliveries.css';

const TrackDeliveriesScreen = () => {
	return <div>TrackDeliveriesScreen</div>;
};

export default TrackDeliveriesScreen;
